__webpack_require__.p = "/curriculo/";